import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Notification, NotificationCategories } from '@core/domain/model/notifications/notification.model';
import { NotificationCounters } from '@core/domain/model/notifications/notification-counter.model';

export const notificationsActions = createActionGroup({
  source: 'Notifications',
  events: {
    setCategory: props<{ category: NotificationCategories }>(),
    fetchAll: emptyProps(),
    setNotifications: props<{ notifications: Notification[] }>(),
    errorNotifications: props<{ error: string }>(),
    fetchCounters: emptyProps(),
    setCounters: props<{ counters: NotificationCounters }>(),
    readAll: emptyProps(),
    setReadAll: emptyProps(),
    readOne: props<{ notificationId: number }>(),
    setReadOne: props<{ notificationId: number }>(),
    archiveAll: emptyProps(),
    archiveOne: props<{ notificationId: number }>(),
    unArchiveOne: props<{ notificationId: number }>(),
  },
});
